import Cookies from "js-cookie";
import Swal from "sweetalert2";
// import {
//   encryptLocalStorageItem,
//   decryptLocalStorageItem,
//   removeLocalStorageItem
// } from '../utils/localStorageEncrypt';

const getBrowserId = () => Cookies.get("browserId");

export const getAccessToken = () => {
  const browserId = getBrowserId();
  if (!browserId) return null;
  // return decryptLocalStorageItem("accessToken", browserId);
};

export const getRefreshToken = () => {
  const browserId = getBrowserId();
  if (!browserId) return null;
  // return decryptLocalStorageItem("refreshToken", browserId);
};

export const getUserId = () => {
  const browserId = getBrowserId();
  if (!browserId) return null;
  // return decryptLocalStorageItem("user_id", browserId);
};

export const setAuthTokens = (accessToken, refreshToken, userId) => {
  const browserId = getBrowserId();
  if (!browserId) {
    console.error("Browser ID not found. Cannot set auth tokens securely.");
    return false;
  }
  // encryptLocalStorageItem("accessToken", accessToken, browserId);
  // encryptLocalStorageItem("refreshToken", refreshToken, browserId);
  // encryptLocalStorageItem("user_id", userId, browserId);
  return true;
};

export const clearAuthTokens = () => {
  // removeLocalStorageItem("accessToken");
  // removeLocalStorageItem("refreshToken");
  // removeLocalStorageItem("user_id");
  Cookies.remove("browserId");
};

export const refreshAuthTokens = async () => {
  const refreshToken = getRefreshToken();
  const browserId = getBrowserId();

  if (!refreshToken || !browserId) {
    console.warn("No refresh token or browser ID available for token refresh.");
    logoutUser();
    throw new Error("No session available. Please log in.");
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}users/refresh-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Browser-ID": browserId,
        },
        body: JSON.stringify({ refreshToken: refreshToken }),
      },
    );

    const data = await response.json();

    if (response.ok && data.success === "1") {
      setAuthTokens(data.accessToken, data.refreshToken, data.user_id);
      console.log("Tokens successfully refreshed.");
      return data.accessToken;
    } else {
      console.error("Token refresh failed:", data.message || "Unknown error");
      logoutUser();
      throw new Error(
        data.message || "Failed to refresh session. Please log in again.",
      );
    }
  } catch (error) {
    console.error("Error during token refresh:", error);
    logoutUser();
    throw error;
  }
};

export const logoutUser = (navigate = null) => {
  // alert("opopopop");
  // clearAuthTokens();
  // Swal.fire({
  //   title: "Logged Out",
  //   text: "You have been successfully logged out.",
  //   icon: "info",
  //   confirmButtonText: "OK",
  // }).then(() => {
  //   if (navigate) {
  //     navigate("/");
  //   } else {
  //     window.location.href = "/";
  //   }
  // });
};

export const fetchWithAuth = async (url, options = {}, retries = 1) => {
  let accessToken = getAccessToken();
  const browserId = getBrowserId();

  if (!browserId) {
    console.error("Browser ID not found. Cannot make authenticated request.");
    logoutUser();
    throw new Error("Session invalid. Please log in.");
  }

  if (!accessToken) {
    console.log("Access token missing. Attempting to refresh...");
    try {
      accessToken = await refreshAuthTokens();
    } catch (refreshError) {
      throw refreshError;
    }
  }

  const defaultHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
    "X-Browser-ID": browserId,
  };

  const finalOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, finalOptions);

    if (response.status === 401) {
      const errorData = await response.json();
      if (
        errorData.message ===
          "Access token expired. Please refresh your token." &&
        retries > 0
      ) {
        console.warn("Access token expired, attempting refresh and retry...");
        try {
          const newAccessToken = await refreshAuthTokens();
          finalOptions.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return fetchWithAuth(url, finalOptions, retries - 1);
        } catch (refreshError) {
          throw refreshError;
        }
      } else {
        console.error(
          "Unauthorized request or refresh failed:",
          errorData.message,
        );
        logoutUser();
        throw new Error(
          errorData.message || "Unauthorized request. Please log in again.",
        );
      }
    }

    return response;
  } catch (error) {
    console.error("API call error:", error);
    throw error;
  }
};
